<template>
    <div class="home">
        <div class="header">
            <img class="logo" src="~@/assets/logo.gif" alt="mgbx" />
            <div class="register" @click="h5()">Register</div>
        </div>
        <div class="topic1">
            <div class="title">Download MGBX App Now</div>
            <div class="desc">
                MGBX introduces a heavy welcome plan, with a maximum of
                <span class="g">30,000 USDT</span>
            </div>
            <div class="bg">
                <img class="bg-pic" src="~@/assets/download-app-bg.png" alt="" />
            </div>
            <div class="btn" @click="ios()" id="downloadButton">
                <svg t="1783750651097" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="10745" width="16" height="16">
                    <path
                        d="M521.995587 236.597895a154.138947 154.138947 0 0 0 35.031579-4.850527h5.389474a179.469474 179.469474 0 0 0 35.570526-16.168421h4.850527a209.650526 209.650526 0 0 0 30.72-20.48l3.772631-3.233684a234.442105 234.442105 0 0 0 26.947369-26.947368l3.233684-3.233684a242.526316 242.526316 0 0 0 22.096842-32.336843v-3.772631a232.825263 232.825263 0 0 0 16.168421-36.648421V86.231579a211.267368 211.267368 0 0 0 9.162105-39.882105 188.092632 188.092632 0 0 0 0-42.037895A227.435789 227.435789 0 0 0 512.294535 236.058947zM813.027166 616.016842a218.812632 218.812632 0 0 1-14.551579-86.231579 212.345263 212.345263 0 0 1 10.24-57.667368 215.578947 215.578947 0 0 1 26.408421-53.894737 245.221053 245.221053 0 0 1 71.141053-68.985263 236.597895 236.597895 0 0 0-154.138947-97.549474 250.610526 250.610526 0 0 0-35.031579-4.311579h-65.212632l-15.629474 4.311579-11.856842 3.772632-15.090526 5.389473-10.778947 8.623158-17.785263 7.006316-14.551579 5.928421-10.24 3.772632-12.39579 3.772631h-7.006316a73.296842 73.296842 0 0 1-16.707368 0 77.608421 77.608421 0 0 1-16.168421 0h-5.928421l-11.856842-3.233684-8.623158-3.233684-12.39579-3.233684-20.48-8.084211L436.302956 269.473684l-14.551579-5.389473-9.701053-3.233685-13.473684-4.311579H388.33664l-14.012632-2.694736h-10.778947L350.610324 250.071579A256.538947 256.538947 0 0 0 254.138745 269.473684 291.570526 291.570526 0 0 0 81.13664 554.576842v53.894737c0 4.311579 0 19.402105 3.772632 29.103158s0 10.778947 3.233684 16.168421 3.233684 17.246316 5.389473 25.869474 3.233684 11.317895 4.850527 16.707368 4.311579 16.168421 7.006316 24.252632 4.311579 11.856842 6.467368 17.785263l8.084211 22.635789 7.545263 17.246316c3.233684 7.006316 5.928421 14.551579 9.162105 21.557895l8.08421 16.168421 10.778948 21.018947 9.162105 15.629474 11.317895 19.402105 9.701052 14.551579 11.856843 17.785263 10.24 13.473684 12.395789 15.629474 10.778947 12.39579 12.39579 13.473684 11.317895 10.778947 12.395789 11.317895 11.317895 8.623158 12.395789 9.162105 11.317895 6.467368 11.856842 6.467369 10.778948 3.772631 11.856842 3.772632L350.610324 1024H363.006114a161.684211 161.684211 0 0 0 43.115789-7.545263 331.991579 331.991579 0 0 1 126.652632-34.492632 198.871579 198.871579 0 0 1 26.947368 0h8.623158l14.551579 3.233684 9.162105 2.694737 11.317895 3.772632 9.701053 3.772631 14.012631 5.928422 12.39579 5.389473 8.08421 2.694737 10.778948 3.772632H704.159798a154.138947 154.138947 0 0 0 95.393684-44.193685 551.882105 551.882105 0 0 0 119.107369-165.995789 568.050526 568.050526 0 0 0 24.791578-51.738947 247.915789 247.915789 0 0 1-130.425263-135.27579z"
                        p-id="10746" fill="#2c2c2c"></path>
                </svg>
                &nbsp;
                <div>App store</div>
            </div>
            <div class="btn1" @click="apk()">
                <svg t="1783750589131" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="7059" width="16" height="16">
                    <path
                        d="M653.68832 90.0096l53.54624-77.62432c2.28736-3.31136 1.44896-7.8912-1.86752-10.17088l-1.33504-0.92672c-3.3216-2.28736-7.88992-1.44384-10.176 1.87264L638.7712 83.00928c-35.97184-15.5968-76.11264-24.30336-118.46272-24.30336-40.18304 0-78.39872 7.84768-112.93568 21.97504L354.74304 4.3904c-2.28736-3.32288-6.86592-4.15488-10.176-1.8688l-1.33504 0.9152c-3.31648 2.28736-4.15872 6.86976-1.87776 10.1824l50.8928 73.76896c-80.02048 38.23232-137.52832 111.13216-149.23776 197.21216l554.59584 0C786.17344 200.44544 730.93632 128.88064 653.68832 90.0096zM403.53792 201.20448c-15.26144 0-27.63648-12.37376-27.63648-27.63648 0-15.26272 12.37504-27.63264 27.63648-27.63264 15.25632 0 27.63136 12.36864 27.63136 27.63264C431.16928 188.83072 418.79552 201.20448 403.53792 201.20448zM642.08896 201.20448c-15.26272 0-27.63648-12.37376-27.63648-27.63648 0-15.26272 12.37504-27.63264 27.63648-27.63264 15.26272 0 27.63136 12.36864 27.63136 27.63264C669.72032 188.83072 657.35168 201.20448 642.08896 201.20448z"
                        fill="#ffffff" p-id="7060"></path>
                    <path
                        d="M137.05728 324.80384l12.24832 0c30.32576 0 55.13088 31.75424 55.13088 70.56768l0 226.40768c0 38.83264-24.80512 70.57664-55.13088 70.57664l-12.24832 0c-30.33088 0-55.13728-31.744-55.13728-70.57664L81.92 395.37024C81.92 356.55808 106.7264 324.80384 137.05728 324.80384L137.05728 324.80384z"
                        fill="#ffffff" p-id="7061"></path>
                    <path
                        d="M895.14368 326.14784l12.25472 0c30.32064 0 55.12576 31.74912 55.12576 70.56768l0 226.4128c0 38.81728-24.80512 70.57664-55.12576 70.57664l-12.25472 0c-30.32576 0-55.13728-31.75936-55.13728-70.57664L840.0064 396.71552C840.0064 357.89696 864.81792 326.14784 895.14368 326.14784L895.14368 326.14784z"
                        fill="#ffffff" p-id="7062"></path>
                    <path
                        d="M472.81664 824.47872l0 127.61856c0 38.7968-24.8 70.55488-55.13088 70.55488l-12.25472 0c-30.32448 0-55.12576-31.75808-55.12576-70.55488l0-127.61856-50.70976 0c-31.01568 0-56.38784-25.37088-56.38784-56.39808L243.20768 321.32992l558.6304 0 0 446.75072c0 31.0272-25.37088 56.39808-56.38784 56.39808l-46.51008 0 0 129.10336c0 38.81216-24.81024 69.2928-55.13088 69.2928l-12.25344 0c-30.32576 0-55.12704-30.47936-55.12704-69.2928L576.4288 824.47872 472.81664 824.47872 472.81664 824.47872z"
                        fill="#ffffff" p-id="7063"></path>
                </svg>
                &nbsp;
                <div>Android Apk</div>
            </div>
            <div class="btn1" @click="h5()" style="margin-top: 12px">
                <svg t="1783752235051" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="22870" width="16" height="16">
                    <path
                        d="M768 0H256C184.832 0 128 57.6 128 128v768c0 70.4 57.6 128 128 128h512c70.4 0 128-57.6 128-128V128c0.768-70.4-56.768-128-128-128zM384 96c0-17.6 14.4-32 32-32h192c17.6 0 32 14.4 32 32s-14.4 32-32 32h-192a32.064 32.064 0 0 1-32-32zM512 960c-35.2 0-64-28.8-64-64s28.8-64 64-64 64 28.8 64 64-28.8 64-64 64z m320-204.032c0 6.4-5.632 12.032-12.032 12.032H204.032A12.288 12.288 0 0 1 192 755.968V204.032c0-6.4 5.568-12.032 12.032-12.032h615.936c6.4 0 12.032 5.568 12.032 12.032v551.936z"
                        fill="#ffffff" p-id="22871"></path>
                    <path
                        d="M703.232 584v-0.832a209.6 209.6 0 0 0 12.8-128v-1.6a209.664 209.664 0 0 0-168-160h-1.6a238.912 238.912 0 0 0-34.368-3.2 209.92 209.92 0 0 0-204.032 163.2v1.6c-3.2 14.4-4.8 29.632-4.8 44.8v8.832c0 8.768 7.232 14.4 16 14.4a14.272 14.272 0 0 0 14.4-16v-7.232c0-8.768 0.832-18.368 2.432-27.2h56.768v8.832a15.168 15.168 0 1 0 30.4 0v-8.832h73.6v24a15.168 15.168 0 1 0 30.4 0v-24h73.6v8.832c0 26.368-3.2 51.2-9.6 75.2-2.368 8 2.432 16.768 10.432 18.368 1.6 0 2.368 0.832 3.968 0.832 6.4 0 12.8-4.8 14.4-11.2 7.232-26.432 11.2-53.632 11.2-83.2v-8.832h56.832c1.6 8.832 2.368 17.6 2.368 27.2 0 24.832-5.568 48.832-15.168 71.232-4.8 6.4-32 41.6-95.232 46.4-8.768 0.768-16 0.768-23.168 0.768-33.6 0-62.4-8-90.432-24l34.432-35.968c3.968-4.8 5.568-11.2 3.2-16.832a14.784 14.784 0 0 0-13.632-8.768h-137.6a15.744 15.744 0 0 0-15.168 15.168v137.6c0 6.4 3.968 12.032 9.6 14.4 5.568 2.432 11.968 0.832 16.768-3.2l34.432-34.368c19.2 16.768 60.8 47.168 114.368 47.168 62.4 0 149.632-32 189.632-121.6v-0.768c0-1.6 0.768-2.432 0.768-3.2zM484.864 323.2c3.968-0.832 8-0.832 11.968-1.6V371.2a130.176 130.176 0 0 1-44.8-12.8c9.6-15.232 20.032-27.2 32.832-35.2z m42.368-1.6c4.032 0 8 0.768 12.032 1.6 11.968 7.168 23.168 19.968 32 35.2-13.632 6.4-28.8 11.2-44.032 12.8v-49.6zM343.232 442.368c11.2-32.768 32-61.568 59.2-83.2 0.832 2.432 2.432 4.032 4.8 6.4 2.432 1.6 4.032 3.2 6.4 4.8a285.44 285.44 0 0 0-18.368 72.832l-52.032-0.832z m82.432 0c2.368-20.8 7.168-40 13.568-56.768 18.432 8.768 37.632 14.4 57.6 16v40.768H425.664z m101.568 0v-40.768c20.032-1.6 39.232-7.232 57.6-16 6.4 16.768 11.2 35.968 14.4 56.768H527.232z m102.4 0a279.232 279.232 0 0 0-18.368-72c2.368-1.6 3.968-3.2 6.4-4.8a12.416 12.416 0 0 0 4.8-6.4c27.2 21.632 48 49.6 59.2 83.2h-52.032z m-117.568 251.2V678.4c-59.2 0-103.232-48-103.232-48-2.368-3.2-6.4-4.8-11.2-4.8h-0.768a12.928 12.928 0 0 0-10.432 4.8l-18.368 17.6V562.368h87.168l-22.4 24a13.184 13.184 0 0 0-3.968 12.032 18.048 18.048 0 0 0 6.4 11.2c36.8 26.368 76.8 39.168 122.368 39.168 8 0 16 0 25.6-0.768 14.4-0.832 27.2-4.032 38.4-7.232l-9.6 7.232c-0.768 0-0.768 0.768-1.6 0.768-32 20.8-67.968 28.8-98.368 28.8v16z"
                        fill="#ffffff" p-id="22872"></path>
                </svg>
                &nbsp;
                <div>Website</div>
            </div>
        </div>

        <div class="topic2">
            <div class="title1">Why Choose MGBX</div>
            <div class="safe">
                <div class="safe-t">Top-tier Security</div>
                <div class="safe-t1">
                    Expert-level protection for your digital assets
                </div>
                <div class="safe-d">
                    Multi-layer asset protection: User funds stored in cold wallets.
                </div>
                <div class="safe-d1">
                    Privacy protection encryption: User information and asset privacy
                    are encrypted.
                </div>
                <div class="safe-pic">
                    <img src="~@/assets/safebox.png" alt="" />
                </div>
            </div>
            <div class="item">
                <div class="item-pic">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                        <path
                            d="M22.6289 14.6321C21.5696 14.6159 20.5387 14.2871 19.6658 13.6869C18.7928 13.0866 18.1167 12.2418 17.7225 11.2584C17.3282 10.2751 17.2334 9.1972 17.4499 8.16015C17.6664 7.12309 18.1846 6.17317 18.9393 5.42973C19.6941 4.68629 20.6517 4.1825 21.6919 3.98168C22.7321 3.78085 23.8085 3.89195 24.7857 4.30101C25.763 4.71006 26.5976 5.39883 27.1846 6.28075C27.7715 7.16268 28.0848 8.19843 28.0849 9.25784C28.0796 9.96897 27.9342 10.6721 27.6571 11.327C27.38 11.982 26.9766 12.5759 26.47 13.075C25.9633 13.574 25.3634 13.9684 24.7043 14.2355C24.0453 14.5027 23.34 14.6374 22.6289 14.6321ZM22.6289 16.7378C24.1033 16.7156 25.5382 16.258 26.7534 15.4227C27.9685 14.5874 28.9096 13.4116 29.4585 12.043C30.0074 10.6744 30.1395 9.17405 29.8383 7.73059C29.537 6.28713 28.8159 4.9649 27.7654 3.93007C26.715 2.89523 25.3821 2.19396 23.9343 1.91438C22.4865 1.63479 20.9883 1.78936 19.6281 2.35867C18.2678 2.92798 17.1062 3.88663 16.2892 5.11414C15.4722 6.34166 15.0362 7.78328 15.036 9.25784C15.051 11.2566 15.8594 13.1675 17.2834 14.5703C18.7073 15.9731 20.6301 16.7527 22.6289 16.7378ZM7.0929 17.1663C6.4758 17.157 5.87522 16.9655 5.36662 16.6159C4.85802 16.2663 4.46409 15.7742 4.23435 15.2014C4.0046 14.6286 3.94929 14.0006 4.07535 13.3965C4.20142 12.7923 4.50324 12.2389 4.94289 11.8058C5.38254 11.3727 5.9404 11.0791 6.54637 10.9621C7.15234 10.8451 7.77938 10.9098 8.34869 11.148C8.91801 11.3863 9.4042 11.7875 9.74616 12.3013C10.0881 12.8151 10.2706 13.4184 10.2707 14.0356C10.2641 14.872 9.92566 15.6715 9.32976 16.2584C8.73385 16.8453 7.92927 17.1724 7.0929 17.1663ZM7.0929 19.2721C8.1251 19.2565 9.12966 18.9361 9.98033 18.3513C10.831 17.7665 11.4899 16.9433 11.8741 15.9851C12.2583 15.0269 12.3507 13.9766 12.1397 12.9661C11.9288 11.9555 11.4238 11.0299 10.6883 10.3055C9.95286 9.58112 9.01969 9.09027 8.00608 8.89465C6.99247 8.69903 5.94365 8.80737 4.99143 9.20606C4.03921 9.60475 3.22608 10.276 2.65422 11.1354C2.08236 11.9949 1.77729 13.0042 1.77734 14.0365C1.78815 15.4356 2.3542 16.7731 3.35102 17.755C4.34783 18.7368 5.69379 19.2825 7.0929 19.2721Z"
                            fill="currentColor"></path>
                        <path
                            d="M3.83981 23.5254C3.73581 22.953 4.33759 22.3699 5.18203 22.2187L27.726 18.2463C28.5723 18.0961 29.342 18.4401 29.446 19.0125C29.55 19.585 28.9483 20.1681 28.1038 20.3192L5.55981 24.2907C4.71359 24.441 3.94381 24.097 3.83981 23.5254Z"
                            fill="var(--Text-Themes, #C5FF30)"></path>
                        <path
                            d="M17.9667 24.5342C18.1787 24.5327 18.3854 24.6008 18.5551 24.728C18.645 24.7983 18.7308 24.8737 18.812 24.9538L18.8618 25.0027C19.7588 25.9539 20.4982 27.0423 21.052 28.2267C21.1624 28.4651 21.2381 28.718 21.2769 28.9778V29.0098C21.2764 29.1951 21.2253 29.3768 21.1292 29.5351C21.033 29.6935 20.8953 29.8226 20.7311 29.9085C20.4923 29.9924 20.2471 30.0567 19.9978 30.1005C19.3217 30.1879 18.6404 30.2286 17.9587 30.2222C17.255 30.2337 16.5517 30.1876 15.8555 30.0845C15.6571 30.0472 15.4609 29.9986 15.268 29.9387C15.0567 29.847 14.8815 29.6883 14.7693 29.4871C14.69 29.3291 14.6486 29.1547 14.6484 28.9778C14.6811 28.7471 14.7433 28.5216 14.8333 28.3067C15.3908 27.095 16.1413 25.9818 17.0555 25.0107C17.1684 24.8987 17.3053 24.776 17.3373 24.744C17.5168 24.6058 17.7374 24.5316 17.964 24.5334"
                            fill="currentColor"></path>
                    </svg>
                </div>
                <div class="item-t">Flexible Leverage</div>
                <div class="item-d">
                    5-200X flexible leverage options to meet different trading
                    strategies.
                </div>
            </div>
            <div class="item">
                <div class="item-pic">
                    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
                        <path
                            d="M21.2557 5.43682C21.6156 4.0297 20.5269 2.66663 19.0431 2.66663H12.3225C11.2846 2.66663 10.3776 3.35162 10.1156 4.33333L6.37151 18.3631C6.18303 19.0694 6.72826 19.7592 7.47496 19.7592H10.6411C11.3765 19.7592 11.9196 20.4295 11.7512 21.1293L10.0272 28.2915C9.75907 29.4053 11.1764 30.1438 11.9729 29.3053L27.027 13.4578C27.7046 12.7445 27.1871 11.5845 26.1914 11.5845H19.6835L21.2557 5.43682Z"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        </path>
                        <path d="M14.334 7.66663L13.334 13.6666" stroke="var(--Text-Themes, #C5FF30)" stroke-width="2"
                            stroke-linecap="round"></path>
                    </svg>
                </div>
                <div class="item-t">High-Speed Trading</div>
                <div class="item-d">
                    Ultra-low latency for an exhilarating trading experience.
                </div>
            </div>
            <div class="item">
                <div class="item-pic">
                    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
                        <path
                            d="M25.6667 16H28.3333C29.0697 16 29.6667 15.403 29.6667 14.6666V12M28.3333 14.6666C17.7446 6.14481 12.2562 3.84938 3 2.66663"
                            stroke="var(--Text-Themes, #C5FF30)" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round"></path>
                        <path
                            d="M5.66667 10.6667C4.19391 10.6667 3 11.8607 3 13.3334L3 26.6667C3 28.1395 4.19391 29.3334 5.66667 29.3334C7.13943 29.3334 8.33333 28.1395 8.33333 26.6667L8.33333 13.3334C8.33333 11.8607 7.13943 10.6667 5.66667 10.6667Z"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        </path>
                        <path
                            d="M27 21.3334C25.5272 21.3334 24.3333 22.5273 24.3333 24.0001V26.6667C24.3333 28.1395 25.5272 29.3334 27 29.3334C28.4728 29.3334 29.6667 28.1395 29.6667 26.6667V24.0001C29.6667 22.5273 28.4728 21.3334 27 21.3334Z"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        </path>
                        <path
                            d="M16.3333 16.0001C14.8606 16.0001 13.6667 17.194 13.6667 18.6667V26.6667C13.6667 28.1395 14.8606 29.3334 16.3333 29.3334C17.8061 29.3334 19 28.1395 19 26.6667V18.6667C19 17.194 17.8061 16.0001 16.3333 16.0001Z"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        </path>
                    </svg>
                </div>
                <div class="item-t">Low Trading Fees</div>
                <div class="item-d">Trading fee rate as low as 0.02%.</div>
            </div>
            <div class="item">
                <div class="item-pic">
                    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
                        <rect x="3.33203" y="2.66663" width="26.6667" height="26.6667" rx="5.33333"
                            stroke="currentColor" stroke-width="2"></rect>
                        <circle cx="5.33333" cy="5.33333" r="5.33333" transform="matrix(1 0 0 -1 11.332 21.3334)"
                            stroke="var(--Text-Themes, #C5FF30)" stroke-width="2"></circle>
                        <path d="M16.666 10.6667V8" stroke="var(--Text-Themes, #C5FF30)" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M16.666 24V21.3334" stroke="var(--Text-Themes, #C5FF30)" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M21.464 12.6667L23.7734 11.3334" stroke="var(--Text-Themes, #C5FF30)" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M9.55974 20.6667L11.8691 19.3334" stroke="var(--Text-Themes, #C5FF30)" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M21.464 19.3333L23.7734 20.6666" stroke="var(--Text-Themes, #C5FF30)" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M9.55974 11.3333L11.8691 12.6666" stroke="var(--Text-Themes, #C5FF30)" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </div>
                <div class="item-t">Funding Rate Benefits</div>
                <div class="item-d">
                    0.015% funding rate cap, saving you more on trading costs.
                </div>
            </div>
            <div class="item">
                <div class="item-pic">
                    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
                        <rect x="3.33203" y="2.66663" width="26.6667" height="26.6667" rx="5.33333"
                            stroke="currentColor" stroke-width="2"></rect>
                        <circle cx="5.33333" cy="5.33333" r="5.33333" transform="matrix(1 0 0 -1 11.332 21.3334)"
                            stroke="var(--Text-Themes, #C5FF30)" stroke-width="2"></circle>
                        <path d="M16.666 10.6667V8" stroke="var(--Text-Themes, #C5FF30)" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M16.666 24V21.3334" stroke="var(--Text-Themes, #C5FF30)" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M21.464 12.6667L23.7734 11.3334" stroke="var(--Text-Themes, #C5FF30)" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M9.55974 20.6667L11.8691 19.3334" stroke="var(--Text-Themes, #C5FF30)" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M21.464 19.3333L23.7734 20.6666" stroke="var(--Text-Themes, #C5FF30)" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M9.55974 11.3333L11.8691 12.6666" stroke="var(--Text-Themes, #C5FF30)" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </div>
                <div class="item-t">Strong Protection</div>
                <div class="item-d">
                    50 million USDT risk fund to ensure your fund safety.
                </div>
            </div>
            <div class="item">
                <div class="item-pic">
                    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
                        <g clip-path="url(#clip0_25133_26657)">
                            <path
                                d="M16.3346 9.04318C14.7778 7.56528 12.7218 6.66663 10.468 6.66663C5.60786 6.66663 1.66797 10.8453 1.66797 16C1.66797 21.1546 5.60786 25.3333 10.468 25.3333C12.7218 25.3333 14.7778 24.4346 16.3346 22.9567"
                                stroke="var(--Text-Themes, #C5FF30)" stroke-width="2"></path>
                            <path
                                d="M31.0004 16C31.0004 21.1546 27.0605 25.3333 22.2004 25.3333C19.9466 25.3333 17.8906 24.4346 16.3337 22.9567C14.5334 21.2477 13.4004 18.7642 13.4004 16C13.4004 13.2357 14.5334 10.7522 16.3337 9.04318C17.8906 7.56528 19.9466 6.66663 22.2004 6.66663C27.0605 6.66663 31.0004 10.8453 31.0004 16Z"
                                stroke="currentColor" stroke-width="2"></path>
                        </g>
                        <defs>
                            <clipPath id="clip0_25133_26657">
                                <rect width="32" height="32" fill="currentColor" transform="translate(0.333984)"></rect>
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <div class="item-t">Rich Trading Pairs</div>
                <div class="item-d">
                    200+ popular trading pairs listed in real-time for more trading
                    options.
                </div>
            </div>
        </div>
        <div class="topic3">
            <div class="title">Join Our Community</div>
            <div class="desc1">
                Follow MGBX's social media to get the latest market trends and
                professional analysis first.
            </div>
        </div>
        <div class="footer">
            <div class="footer-logo">
                <img src="~@/assets/logo.gif" alt="" />
            </div>
            <div class="copy">© 2026 MGBX. All rights reserved.</div>
        </div>
        <el-dialog title="Downloading" :visible.sync="isDownloading" top="40vh">
            <el-progress :percentage="downloadProgress" />
        </el-dialog>
    </div>
</template>

<script>
import axios from "axios";
export default {
    name: "Download",
    data() {
        return {
            downloadProgress: 0,
            progressStatus: "",
            isDownloading: false,
            cando: true,
            isAndroid: "",
            isIOS: ''
        }
    },
    mounted() {
        const userAgent = navigator.userAgent;
        this.isAndroid = /Android/i.test(userAgent);
        this.isIOS = /iPhone|iPad|iPod/i.test(userAgent);
        if (this.isIOS || (!this.isAndroid && !this.isIOS)) {
            axios
                .get(window.global.baseUrl + "/install")
                .then((response) => {
                    // 请求成功后的回调函数
                    console.log(response);
                    // setTimeout(() => {
                    //   this.loading = true
                    // }, 2000);
                    this.loading = true;
                    const s = document.createElement("script");
                    s.type = "text/javascript";
                    s.src = "//web.cdn.openinstall.io/openinstall.js";
                    s.addEventListener(
                        "load",
                        () => {
                            var data = {
                                channel: response.data.channel,
                                channelCode: window.global.channelCode,
                            };
                            new OpenInstall(
                                {
                                    appKey: "pjzmnv", //appkey参数配置,需要自行替换对应的appkey
                                    onready: function () {
                                        var m = this,
                                            button = document.getElementById("downloadButton");
                                        m.schemeWakeup();
                                        button.onclick = function () {
                                            m.wakeupOrInstall();
                                            return false;
                                        };
                                    },
                                },
                                data
                            );
                        },
                        false
                    );
                    document.head.appendChild(s);
                })
                .catch((error) => {
                    // 请求失败后的回调函数
                    console.log(error);
                });
        } else {
            this.loading = true;
        }
    },
    methods: {
        ios() {

        },
        // apk() {
        //     window.location.href = window.global.apkLink
        // },
        h5() {
            window.location.href = window.global.h5Link
        },
        async apk() {
            if (this.cando) {
                const url = window.global.apkLink; // 替换为真实的 APK 地址
                this.downloadProgress = 0;
                this.isDownloading = true;

                this.progressStatus = "active";
                this.cando = false;
                try {
                    const response = await axios.get(url, {
                        responseType: "blob",
                        onDownloadProgress: (progressEvent) => {
                            if (progressEvent.lengthComputable) {
                                this.downloadProgress = Math.floor(
                                    (progressEvent.loaded * 100) / progressEvent.total
                                );
                            }
                        },
                    });

                    const blob = new Blob([response.data], {
                        type: "application/vnd.android.package-archive",
                    });
                    const downloadLink = document.createElement("a");
                    downloadLink.href = URL.createObjectURL(blob);
                    downloadLink.download = "MGBX.apk";
                    downloadLink.click();
                    this.progressStatus = "success";
                    this.cando = true;
                } catch (error) {
                    this.progressStatus = "exception";
                    this.$message.error("Download error!");
                    console.error(error);
                    this.cando = true;
                } finally {
                    this.isDownloading = false;
                    this.cando = true;
                }
            } else {
                this.$message.error("Your download is in progress, please wait!");
            }
        },
        updateProgress(event) {
            if (event.lengthComputable) {
                this.downloadProgress = Math.round((event.loaded * 100) / event.total);
            }
        },
    }
}
</script>

<style scoped>
body {
    margin: 0;
    padding: 0;

}

.home {
    width: 100%;
    min-height: 100vh;
    background: #000;
}

.header {
    height: 70px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.logo {
    height: 100%;
    width: 145px;
}

.register {
    margin-right: 20px;
    background: #c5ff30;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
    display: flex;
    padding: 5px 16px;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
}

.topic1 {
    padding: 80px 16px;
    box-sizing: border-box;
    padding-top: 20px;
}

.title {
    color: #f6f6f6;
    font-size: 40px;
    line-height: 48px;
    text-align: center;
    font-weight: bold;
}

.desc {
    color: #a0a0a0;
    margin-top: 16px;
    text-align: center;
    font-size: 16px;
    line-height: 24px;
}

.g {
    color: #c5ff30;
}

.bg {
    margin-top: 32px;
    text-align: center;
}

.bg-pic {
    height: 393px;
    width: 100%;
}

.btn {
    font-size: 12px;
    background-color: #c5ff30;
    width: 100%;
    height: 40px;
    line-height: 40px;
    margin-top: 32px;
    margin-bottom: 12px;
    border-radius: 100px;
    cursor: pointer;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn1 {
    font-size: 12px;
    width: 100%;
    height: 40px;
    line-height: 40px;
    border: 1px solid #39393b;
    border-radius: 100px;
    cursor: pointer;
    text-align: center;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}

.topic2 {
    padding: 80px 16px;
    box-sizing: border-box;
}

.title1 {
    color: #fff;
    font-size: 40px;
    line-height: 48px;
}

.safe {
    margin-top: 52px;
    border: 1px solid #19191a;
    padding: 24px;
    box-sizing: border-box;
    border-radius: 16px;
    background: #0d0d0e;
}

.safe-t {
    color: #fff;
    font-size: 20px;
    line-height: 28px;
}

.safe-t1 {
    color: #fff;
    margin-top: 4px;
    font-size: 16px;
    line-height: 24px;
}

.safe-d {
    color: #a0a0a0;
    margin-top: 16px;
    font-size: 14px;
    line-height: 22px;
}

.safe-d1 {
    color: #a0a0a0;
    font-size: 14px;
    line-height: 22px;
}

.safe-pic {
    margin-top: 10px;
    height: 170px;
    width: 170px;

    img {
        height: 100%;
        width: 100%;
    }
}

.item {
    margin-top: 16px;
    background: #0d0d0e;
    border: 1px solid #19191a;
    border-radius: 16px;
    padding: 24px;
    box-sizing: border-box;
}

.item-pic {
    height: 32px;
    width: 32px;
    color: #fff;

    img {
        height: 100%;
        width: 100%;
    }
}

.item-t {
    margin-top: 24px;
    color: #f6f6f6;
    font-size: 20px;
    line-height: 28px;
}

.item-d {
    color: #707070;
    margin-top: 8px;
    font-size: 12px;
    line-height: 18px;
}

.topic3 {
    padding: 80px 16px;
    box-sizing: border-box;
}

.desc1 {
    color: #a0a0a0;
    margin-top: 8px;
    width: 100%;
    text-align: center;
    font-size: 14px;
    line-height: 22px;
}

.footer {
    display: flex;
    align-items: center;
    justify-content: center;
}

.footer-logo {
    width: 72px;
    height: 36px;

    img {
        height: 100%;
        width: 100%;
    }
}

.copy {
    color: #a0a0a0;
    font-size: 14px;
    line-height: 22px;
}
</style>
